import cmsContentMixin from '@/mixins/cmsContent';

const PODCAST_LAYOUT_REFRESH_EVENT = 'cms:podcast-layout-refresh';

export default {
  mixins: [
    cmsContentMixin,
  ],
  props: {
    detailData: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      storyContent: '',
      resizeObserver: null,
    };
  },
  methods: {
    emitPodcastLayoutRefresh() {
      window.dispatchEvent(new Event(PODCAST_LAYOUT_REFRESH_EVENT));
    },
    setupResizeObserver() {
      if (typeof ResizeObserver === 'undefined' || !this.$el) {
        return;
      }
      this.teardownResizeObserver();
      this.resizeObserver = new ResizeObserver(() => {
        this.emitPodcastLayoutRefresh();
      });
      this.resizeObserver.observe(this.$el);
    },
    teardownResizeObserver() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
    },
    refreshSurface() {
      const data = this.detailData || {};
      const cmsContentObject = data.cmsContentObject || {};
      this.storyContent = `${data.bodyCSS || ''}${data.bodyHTML || ''}`;
      this.$nextTick(() => {
        this.installDynamicControls({
          data: {
            cmsContentObject,
          },
        });
        this.$nextTick(() => {
          this.setupResizeObserver();
          this.emitPodcastLayoutRefresh();
          setTimeout(() => this.emitPodcastLayoutRefresh(), 200);
        });
      });
    },
  },
  watch: {
    detailData: {
      handler() {
        this.refreshSurface();
      },
      deep: true,
    },
  },
  mounted() {
    this.refreshSurface();
  },
  beforeDestroy() {
    this.teardownResizeObserver();
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-story-preview/story-preview-detail-surface.js